import type { ColumnFilterItem } from 'antd/lib/table/interface';
import { get, isArray } from 'lodash/fp';
import { Timeframe } from '../api/types';
import useTranslatedString from './useTranslatedString';

export const dateFilterItems = [
    {
        text: 'Current month',
        value: Timeframe.CurrentMonth,
    },
    {
        text: 'Last month',
        value: Timeframe.LastMonth,
    },
    {
        text: 'Last 3 months',
        value: Timeframe.Last3Months,
    },
];

export const monthDiff = (dateFrom, dateTo) =>
    dateTo.getMonth() - dateFrom.getMonth() + 12 * (dateTo.getFullYear() - dateFrom.getFullYear());

export const mapToDistinctFilterItems = <T extends object = any>(data: T[], property: string): ColumnFilterItem[] =>
    Array.from(new Set(data.map(item => get(property, item)?.toLocaleString())).values()).map<ColumnFilterItem>(
        item => ({
            text: item,
            value: item,
        })
    );

export const mapToDistinctFilterArrayItems = (data: string[]): ColumnFilterItem[] =>
    Array.from(new Set(data.map(item => item?.toLocaleString())).values()).map<ColumnFilterItem>(item => ({
        text: item,
        value: item,
    }));

export const mapToDistinctFilterNestedDocument = <T extends object = any>(
    data: T[],
    property: keyof T,
    subProperty: string
): ColumnFilterItem[] => {
    const translate = useTranslatedString();

    return Array.from(
        new Set(data.map(item => item[property][subProperty].toLocaleString())).values()
    ).map<ColumnFilterItem>(item => ({
        text: item,
        value: translate(item[subProperty]),
    }));
};

export const checkHasFilter = filter =>
    filter && Object.keys(filter).filter(i => (isArray(filter[i]) && filter[i].length > 0) || filter[i]).length > 0;
